import React, { Component } from 'react';
import { Helmet } from "react-helmet";

export default class extends Component {
    render() {
        return (
            <Helmet>
                <title>{this.props.meta.webSiteTitle}</title>
                <link rel="icon" href={this.props.meta.faviconUrl} type="image/png" />

                <meta name="description" content={this.props.meta.shareInfo}></meta>

                {/* Facebook Open Graph Data */}
                <meta property="og:title" content={this.props.meta.shareTitle}/>
                <meta property="og:type" content={this.props.meta.shareType}/>
                <meta property="og:url" content={this.props.meta.shareUrl}/>
                <meta property="og:image" content={this.props.meta.shareImgUrl}/>
                <meta property="og:description" content={this.props.meta.shareInfo} />

                {/* twitter Open Graph Data */}
                <meta name="twitter:card" content="summary"/>
                <meta name="twitter:title" content={this.props.meta.shareTitle}/>
                <meta name="twitter:url" content={this.props.meta.shareUrl}/>
                <meta name="twitter:image" content={this.props.meta.shareImgUrl}/>
                <meta name="twitter:description" content={this.props.meta.shareInfo} />
            </Helmet>
            
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DocumentMeta.js